// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Hash } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconHash(props: any) {
    return <IconBase icon={Hash} {...props} />
  }

  export default IconHash
  